import React from "react";
import { Col } from "reactstrap";
import ImageArea from "components/Common/ImageArea";
import { SignatureImageImproved } from "../../../utils/SignatureImage";
const formatter = (vals) => {
  if (vals && Array.isArray(vals)) {
    let [yesVal, NaVal] = vals;

    return (
      <span style={{ fontSize: "14px" }}>
        {typeof NaVal === "boolean" && NaVal ? "N/A" : typeof yesVal === "boolean" && yesVal ? "YES" : " "}
      </span>
    );
  }
};

export const SchemaFor92And184DaysChecklist = {
  labOilSample: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "OIL SAMPLE",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "OBTAIN OIL SAMPLE",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check0",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check0", "check0-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check0_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  replaceAllFilters: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "REPLACE ALL FILTERS",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AIR COMPRESSOR OIL FILTER",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check1",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check1", "check1-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check1_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AIR COMPRESSOR INTAKE AIR FILTER(S)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check1v2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check1v2", "check1v2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check1v2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FUEL OIL SPIN-ON FILTER(S)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check2", "check2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FUEL OIL SUCTION STRAINER ELEMENT / SPIN-ON STRAINER & SEAL",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check3",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check3", "check3-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check3_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FUEL OIL PRIMARY FILTER(S) & SEAL(S)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check4",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check4", "check4-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check4_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ENGINE INTAKE AIR FILTERS (BAGGIES, CARTRIDGE, CYLINDRICAL, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check5v2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check5v2", "check5v2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check5v2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CARBODY DOOR FILTERS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check6v2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check6v2", "check6v2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check6v2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ENGINE LUBE OIL FILTERS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check7",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check7", "check7-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check7_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ELECTRICAL CABINET AIR FILTER(S)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check8",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check8", "check8-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check8_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TURBO SOAK BACK FILTER",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check9",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check9", "check9-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check9_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TURBO LUBE OIL FILTER",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check10",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check10", "check10-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check10_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TRANSMISSION/GEARBOX OIL FILTER",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTGOFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTGOFv2", "checkTGOFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTGOFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "COOLANT FILTER",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCFv2", "checkCFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "HVAC FILTER(S)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkHVACFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkHVACFv2", "checkHVACFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkHVACFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FRESH AIR CAB FILTER",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkFACFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkFACFv2", "checkFACFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkFACFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "I.C.E. BLOWER FILTER ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkICEBFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkICEBFv2", "checkICEBFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkICEBFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  brushFusesDiodes: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "BRUSHES, FUSES & DIODES (INSPECT & REPLACE AS NEEDED)",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TRACTION MOTOR BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check11",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check11", "check11-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check11_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "MAIN GENERATOR BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check12",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check12", "check12-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check12_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ALTERNATOR SLIP RING BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check12v2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check12v2", "check12v2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check12v2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "MAIN GENERATOR/TRACTION ALTERNATOR FUSES & DIODES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkMGAFDv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkMGAFDv2", "checkMGAFDv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkMGAFDv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AUXILIARY GENERATOR BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check13",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check13", "check13-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check13_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FUEL PUMP BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check14",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check14", "check14-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check14_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "LOAD REGULATOR BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check15",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check15", "check15-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check15_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CAB HEATER FAN BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check16",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check16", "check16-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check16_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CAB FAN BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check17",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check17", "check17-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check17_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "DYNAMIC BRAKE FAN BRUSHES (IF EQUIPPED & OPERTIONAL)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check18",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check18", "check18-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check18_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TURBO LUBE PUMP BRUSHES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTLPBv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTLPBv2", "checkTLPBv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTLPBv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TRACTION MOTOR/EQUIPMENT BLOWER MOTOR BRUSHES (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTMBMBv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTMBMBv2", "checkTMBMBv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTMBMBv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK HELWIG BRUSHE(S) ON MAIN GENERATOR (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCHBOMv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCHBOMv2", "checkCHBOMv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCHBOMv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CLEAN ALL INSPECTION WINDOWS ON MAIN GENERATOR COVERS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAIWOMGv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCAIWOMGv2", "checkCAIWOMGv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAIWOMGv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CLEAN & BLOW OUT MAIN GENERATOR.  ALLOW AMPLE TIME TO DRY. ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCBOMGAATTDv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCBOMGAATTDv2", "checkCBOMGAATTDv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCBOMGAATTDv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SPRAY INSULATING VARNISH AS NEEDED INSIDE OF ELECTRIC MOTORS & GENERATORS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSIVANIOEMGv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkSIVANIOEMGv2", "checkSIVANIOEMGv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSIVANIOEMGv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  safetyAppliances: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SAFETY APPLIANCES",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title:
            "INSPECT ALL SAFETY APPLIANCES. REPAIR AS NEEDED (HAND-HOLDS, GRAB IRONS, LADDERS, STEPS, STEP TREADS, CUT LEVERS, VERTICAL STANTIONS, HANDRAILS, WALKWAY TREAD, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkIASARANv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkIASARANv2", "checkIASARANv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkIASARANv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK CLEARANCE ON ALL HANDRAILS, HAND-HOLDS & GRAB IRONS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCCOAHHGIv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCCOAHHGIv2", "checkCCOAHHGIv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCCOAHHGIv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT ALL SAFETY COVERS (STARTER COVER, REMOVABLE COVER(S), DRIVESHAFT COVERS, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkIASCSCRCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkIASCSCRCv2", "checkIASCSCRCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkIASCSCRCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  brakeShoes: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "BRAKE SHOES",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "REPLACE ANY WORN OR DEFECTIVE BRAKE SHOES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check22",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check22", "check22-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check22_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ADJUST ANY OVERLAP OF SHOE RIDING OFF EDGE OF TREAD",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAAOOSROEOTv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkAAOOSROEOTv2", "checkAAOOSROEOTv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAAOOSROEOTv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AMOUNT OF BRAKE SHOES REPLACED",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAOBSRv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAOBSRv2",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAOBSRv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  truckUndercarriage: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TRUCK & UNDERCARRIAGE INSPECTION",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT ALL SPRINGS: CRACKS, BROKEN OR MISALIGNMENT (COIL, LEAF, RUBBER SPRING-PACKS, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check23",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check23", "check23-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check23_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CLEARANCE ON GP TRUCKS BETWEEN BOTTOM OF BOLSTER AND SAFETY HANGER (MINIMUM 3/8” CLEARANCE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check24",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check24", "check24-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check24_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: " SPRING HANGERS ON AAR SWITCHER TRUCK ASSEMBLY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check25",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check25", "check25-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check25_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SAFETY PINS ON AAR SWITCHER TRUCK ASSEMBLY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check26",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check26", "check26-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check26_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FRAME (CRACKS OR DEFORMATION)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check27",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check27", "check27-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check27_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: " BOLTS, PINS, HARDWARE (ANYTHING LOOSE OR MISSING?)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check28",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check28", "check28-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check28_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "BRAKE STRAPS, HANGERS & SLACK ADJUSTERS (CHECK FOR DAMAGE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check29",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check29", "check29-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check29_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SUPPORT BEARING CAP BOLTS (LOOSE OR MISSING.  CHECK SAFETY WIRE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check30",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check30", "check30-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check30_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SAND HOSES, PIPES & NIPPLES (CONDITION & ALIGNMENT)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check31",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check31", "check31-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check31_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSIDE JOURNAL BOXES (FILL LUBRICANT)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check32",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check32", "check32-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check32_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "OUTTER JOURNAL BOXES (FILL LUBRICANT.  UNLESS MARKED “NO FIELD LUBE”)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check33",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check33", "check33-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check33_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CENTER CASTINGS (LUBRICATE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check34",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check34", "check34-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check34_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "GEAR CASE (ADD CRATER GREASE OR HONEY LUBE OIL AS REQUIRED)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check35",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check35", "check35-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check35_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "BTR BEARING HOUSINGS (GREASE AS NEDDED)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkBBHGANv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkBBHGANv2", "checkBBHGANv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkBBHGANv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TRACTION MOTOR CABLES & CONNECTIONS (CHECK FOR LOOSE OR BURNED.  TUG ON CABLES TO CHECK CONNECTION)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTMCCTOCTCCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTMCCTOCTCCv2", "checkTMCCTOCTCCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTMCCTOCTCCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL GROUND WIRES FROM TRACTION MOTOR TO FRAME ARE INTACT.  REPAIR AS NEEDED.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAGWFTMTFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCAGWFTMTFv2", "checkCAGWFTMTFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAGWFTMTFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SHOCK ABSORBERS (REPLACE IF LEAKING OR DAMAGED)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSARILKODv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkSARILKODv2", "checkSARILKODv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSARILKODv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "LATERAL PADS ON GG BEARING BOXES (DAMAGED OR MISSING)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkLPOGGBBv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkLPOGGBBv2", "checkLPOGGBBv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkLPOGGBBv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AXLE ALTERNATORS & PROBES (INSPECT FOR DAMAGE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAAAPIFDv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkAAAPIFDv2", "checkAAAPIFDv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAAAPIFDv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK ALL WEAR PADS FOR EXCESSIVE WEAR (REPLACE AS NECESSARY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAWPFWv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCAWPFWv2", "checkCAWPFWv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAWPFWv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK TRACTION MOTOR NOSE SPRING OR LINK ASSEMBLY (DOG BONE) FOR WEAR. REPLACE OR REPAIR AS NECESSARY.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCTMNSSLAWv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCTMNSSLAWv2", "checkCTMNSSLAWv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCTMNSSLAWv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK ALL TRACTION MOTOR BLOWER DUCTS FOR DAMAGE. REPLACE AS NEEDED.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCTMBDDFDv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCTMBDDFDv2", "checkCTMBDDFDv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCTMBDDFDv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK BRAKE CYLINDER HOSES: 15 YRS. MAX LIFE",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCBCH15YMLv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCBCH15YMLv2", "checkCBCH15YMLv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCBCH15YMLv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  draftGear: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "DRAFT GEAR",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK FOR DAMAGE (COUPLER, CUSHION DEVICE, PINS, KNUCKLE, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check36",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check36", "check36-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check36_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK COUPLER WEAR & CONTOUR",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check37",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check37", "check37-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check37_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "LUBE COUPLER CARRIER WEAR PLATE",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check38",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check38", "check38-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check38_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK FOR PROPER ANTI-CREEP AT LOCK LIFT & CUT-LEVER",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCFPACLLCLv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCFPACLLCLv2", "checkCFPACLLCLv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCFPACLLCLv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  handBrake: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "HANDBRAKE",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK FOR PROPER OPERATION & LUBRICATE",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check39",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check39", "check39-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check39_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST THAT THE HANDBRAKE HOLDS UNIT IN NOTCH 1 W/ LOAD (NO AIR BRAKES APPLIED)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTTHHUIN1WLv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTTHHUIN1WLv2", "checkTTHHUIN1WLv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTTHHUIN1WLv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  inspectAllBaseBolts: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT ALL BASE BOLTS & MOUNTS",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AIR COMPRESSOR",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check40",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check40", "check40-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check40_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "EQUIPMENT RACK",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check41",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check41", "check41-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check41_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "PRIME MOVER/DIESEL ENGINE",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check42",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check42", "check42-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check42_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "MAIN GENERATOR/TRACTION ALTERNATOR",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check43",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check43", "check43-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check43_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AUXILIARY GENERATOR",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check44",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check44", "check44-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check44_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "GEARBOX/TRANSMISSION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkGBTv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkGBTv2", "checkGBTv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkGBTv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  batteriesAndChargingSystem: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "BATTERIES & CHARGING SYSTEM",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK WATER/ELECTROLYTE LEVEL (ADD AS REQUIRED)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check45",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check45", "check45-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check45_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: " INSPECT ALL CONNECTIONS: CABLES & TERMINALS (LOOSE OR BURNED)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check46",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check46", "check46-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check46_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "APPLY INSULATING VARNISH AS REQUIRED",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check48",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check48", "check48-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check48_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "RINSE TOP OF BATTERIES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check49",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check49", "check49-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check49_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "LOAD TEST EACH BATTERY FOR PROPER OPERATING VOLTAGE/CURRENT",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check50",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check50", "check50-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check50_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT SOLAR PANEL(S) & CHARGING SYSTEM FOR OPERATION (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkISPACSFOv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkISPACSFOv2", "checkISPACSFOv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkISPACSFOv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "RECORD CHARGING VOLTAGE (ADJUST VOLTAGE REGULATOR AS NECESSARY, IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkRCVv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkRCVv2",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkRCVv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  electricalGrounds: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ELECTRICAL GROUNDS",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "HIGH VOLTAGE: CHECK FOR HIGH VOLT GROUND IN POWER MODE & SELF LOAD (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check51",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check51", "check51-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check51_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "LOW VOLTAGE: CHECK FOR LOW VOLT GROUND WITH ENGINE RUNNING & SHUT DOWN",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check52",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check52", "check52-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check52_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  lightingAndIllumination: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: " LIGHTING & ILLUMINATION",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "HEADLIGHTS: FRONT & REAR: HI, MED & LOW ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check53",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check53", "check53-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check53_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "DITCHLIGHTS: FRONT & REAR",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check56",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check56", "check56-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check56_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "NUMBER BOARD LIGHTS: FRONT & REAR ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check54",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check54", "check54-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check54_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CLASSIFICATION LIGHTS: FRONT & REAR ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check55",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check55", "check55-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check55_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ENGINE COMPARTMENT LIGHTS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check57",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check57", "check57-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check57_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ELECTRICAL/GENERATOR ROOM LIGHTS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkEGRLv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkEGRLv2", "checkEGRLv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkEGRLv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ALL CAB INTERIOR LIGHTS: OVER-HEAD, READING, STEP & FLOOR ILLUMINATION LIGHTS ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check58",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check58", "check58-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check58_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TOILET ROOM LIGHTS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTRLv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTRLv2", "checkTRLv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTRLv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "GAUGE/INSTRUMENT PANEL LIGHTS ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check66",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check66", "check66-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check66_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SPEED INDICATOR LIGHTS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check59",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check59", "check59-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check59_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "PLATFORM/WALKWAY LIGHTS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check60",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check60", "check60-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check60_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "GROUND/STEPWELL LIGHTS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check65",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check65", "check65-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check65_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: " FUSE TEST LIGHT",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check67",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check67", "check67-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check67_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK ILLUMINATION & FUNCTIONALITY OF ALL SCREENS (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCIAFOASv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCIAFOASv2", "checkCIAFOASv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCIAFOASv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  locksAndSecurement: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "LOCKS & SECUREMENT",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check external cab lock for proper function & lubricate (replace if necessary)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check_external_cab_lock",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check_external_cab_lock", "check_external_cab_lock-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check_external_cab_lock_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check internal cab locks for proper function. (Repair as needed)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check_internal_cab_locks",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check_internal_cab_locks", "check_internal_cab_locks-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check_internal_cab_locks_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check modesty lock for proper function (if applicable)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check_modesty_lock",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check_modesty_lock", "check_modesty_lock-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check_modesty_lock_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check electrical panel locks function properly (if applicable)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check_electrical_panel_locks",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check_electrical_panel_locks", "check_electrical_panel_locks-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check_electrical_panel_locks_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  HouseKeeping: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "HOUSE KEEPING",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "EMPTY ALL TRASH RECEPTACLES IN CAB ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check68",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check68", "check68-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check68_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SWEEP & ORGANIZE CAB INTERIOR AS NEEDED",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSOCANv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkSOCANv2", "checkSOCANv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSOCANv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  pcSystem: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "PC SYSTEM",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK FOR PROPER OPERATION & LIGHT/INDICATOR FUNCTION (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check69",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check69", "check69-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check69_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  electricalCabinets: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ELECTRICAL CABINET",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT ALL WIRING, RELAYS, MODULES & COMPONENTS FOR VISUAL DAMAGE (REPAIR AS NECESSARY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check70",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check70", "check70-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check70_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL BREAKERS & SWITCHES FUNCTION PROPERLY (REPAIR AS NECESSARY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCABFPv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCABFPv2", "checkCABFPv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCABFPv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM SPARE FUSES ARE IN GOOD CONDITION: TEST FOR CONTINUITY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCSFAGCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCSFAGCv2", "checkCSFAGCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCSFAGCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK ALL POWER CONTACTOR & REVERSER POINTS (REPAIR AS NECESSARY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAPCPv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCAPCPv2", "checkCAPCPv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAPCPv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "PNEUMATIC SWITCH GEAR: GREASE REVERSER CONTACTS (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkPSGRGv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkPSGRGv2", "checkPSGRGv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkPSGRGv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  protectiveAndShutdown: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: " PROTECTIVE & SHUT DOWN DEVICES",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "HOT ENGINE PROTECTION: LIGHT, ALARM OR MESSAGE (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check73",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check73", "check73-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check73_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "WHEEL SLIP PROTECTION: LIGHT, ALARM OR MESSAGE (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check74",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check74", "check74-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check74_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "GROUND PROTECTION: LIGHT, ALARM OR MESSAGE (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkGPLAAMv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkGPLAAMv2", "checkGPLAAMv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkGPLAAMv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "NO POWER/NO CHARGE: LIGHT, ALARM OR MESSAGE (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkNPCLAMv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkNPCLAMv2", "checkNPCLAMv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkNPCLAMv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "LOW OIL SHUT DOWN SWITCH: LIGHT, ALARM OR MESSAGE (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkLOSDWLAAMv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkLOSDWLAAMv2", "checkLOSDWLAAMv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkLOSDWLAAMv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "THROTTLE SHUT DOWN",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTSv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTSv2", "checkTSv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTSv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "MU SHUT DOWN SWITCH (CONFIRM IT LOCKS AND REQUIRES MANUAL RESET)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkMUSDWv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkMUSDWv2", "checkMUSDWv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkMUSDWv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ENGINE PROTECTION DEVICE: LOW WATER & CRANK CASE PRESSURE & OVER SPEED",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkEPDLWCCPv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkEPDLWCCPv2", "checkEPDLWCCPv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkEPDLWCCPv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL EMERGENCY FUEL CUT-OFFS (EFCO) FUNCTION PROPERLY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAFEPv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCAFEPv2", "checkCAFEPv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAFEPv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  cabAndLocomotiveSafetyEquipments: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CAB & LOCOMOTIVE SAFETY EQUIPMENT",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "WINDSHIELD WIPERS: OPERATION & BLADE FUNCTION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkWWOBFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkWWOBFv2", "checkWWOBFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkWWOBFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST HORN & CROSSING BELL FOR PROPER OPERATION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTHCBFPOv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTHCBFPOv2", "checkTHCBFPOv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTHCBFPOv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL CAB SEATS ARE FREE FROM TEARS & DEFECTS. REPAIR OR REPLACE AS NEEDED",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCCSFFTRv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCCSFFTRv2", "checkCCSFFTRv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCCSFFTRv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FIRST AID KIT: INSPECT & REPLENISH SUPPLIES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkFAKIRSv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkFAKIRSv2", "checkFAKIRSv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkFAKIRSv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FIRE EXTINGUISHERS: CONFIRM DATE TAG & CHARGE STATUS OF ALL EXTINGUISHER(S)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkFECTCSv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkFECTCSv2", "checkFECTCSv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkFECTCSv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "HEAD-BUMP PROTECTION OVER STAIR WELLS IN WIDE-CAB LOCOMOTIVES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkHBPOSWv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkHBPOSWv2", "checkHBPOSWv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkHBPOSWv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL GLASS/GLAZING IS IN PROPER CONDITION: NO OBSTRUCTIONS, CRACKS OR DEFORMATION HINDERING VIEW",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAGGIPCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCAGGIPCv2", "checkCAGGIPCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAGGIPCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AUXILIARY EMERGENCY BRAKE VALVE OPERTION & IDENTIFICATION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAEBVIAv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkAEBVIAv2", "checkAEBVIAv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAEBVIAv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL DECALS, LABELS & SIGNAGE ON THE LOCOMOTIVE ARE IN GOOD LEGIBLE CONDITION. REPLACE AS NECESSARY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCADLSGCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCADLSGCv2", "checkCADLSGCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCADLSGCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL FRA COMPLIANT STRIPING IS IN GOOD CONDITION (10 YEAR LIFE SPAN)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCFCSGCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCFCSGCv2", "checkCFCSGCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCFCSGCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL HAZMAT PERMITS ARE ON EACH UNIT & HAVE CURRENT DATE",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCFHPOCUv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCFHPOCUv2", "checkCFHPOCUv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCFHPOCUv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM AN ENVIRONMENTAL KIT IS ON EACH UNIT (OIL DRY, OIL MATS, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCEKOUv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCEKOUv2", "checkCEKOUv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCEKOUv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM STOCK OF GLAD HAND SEALS, FUSEES, BRAKE PIPE HOSE & WRENCH IN TOOLBOX OR APPLICABLE STORAGE FACILITY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCSGHFBPHTv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCSGHFBPHTv2", "checkCSGHFBPHTv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCSGHFBPHTv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  controlStandThrottle: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONTROL STAND, THROTTLE FUNCTION & LOAD METER",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONVENTIONAL TYPE: INSPECT FOR DAMAGE & PROPER FUNCTIONALITY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check75",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check75", "check75-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check75_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "DESKTOP TYPE: INSPECT FOR DAMAGE & PROPER FUNCTIONALITY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkDTIFDPFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkDTIFDPFv2", "checkDTIFDPFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkDTIFDPFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: " “DRUM” TYPE: GREASE CONTACTS AND INSPECT FOR DAMAGE & PROPER FUNCTIONALITY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check76",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check76", "check76-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check76_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ENGINE SPEEDS INCREASE & DECREASE IN EACH THROTTLE NOTCH",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCESIDTNv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCESIDTNv2", "checkCESIDTNv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCESIDTNv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM THE REVERSER CHANGES UNIT DIRECTION WHEN MOVED",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCRCUDv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCRCUDv2", "checkCRCUDv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCRCUDv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM DYNAMIC BRAKE SET-UP & ACTIVATION (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCDBSAAv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCDBSAAv2", "checkCDBSAAv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCDBSAAv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL SWITCHES & BUTTONS ACTIVATE THE DESIRED FUNCTION (SAND, BELL, HORN, LIGHTS, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCASBv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCASBv2", "checkCASBv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCASBv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST ALERTER & CONFIRM A PENALTY APPLICATION OCCURS IF NO ACTION IS TAKEN TO RESET (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTACPCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTACPCv2", "checkTACPCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTACPCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALERTER RESETS & DELAYS PENALTY APPLICATION (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCARPDv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCARPDv2", "checkCARPDv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCARPDv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST/CALIBRATE LOAD METER (368 DAY INTERVAL: MAXIMUM 5% DEVIATION)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTCLM368v2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTCLM368v2", "checkTCLM368v2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTCLM368v2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  muReceptaclesJumperCables: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "MU RECEPTACLES, JUMPER CABLES, MU AIR LINES & SLUG CONNECTIONS",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "VISUAL CHECK FOR DAMAGE",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check87",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check87", "check87-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check87_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONTINUITY CHECK OF CABLE(S) (8 to 9 & 9 to 8, others 1 to 1 etc.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check88",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check88", "check88-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check88_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK ALL CABLES FOR SLUG CONNECTIVITY (POWER, HIGH VOLT, MU, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCACFSCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCACFSCv2", "checkCACFSCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCACFSCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT ALL AIR HOSES. REPLACE AS NEEDED. (8 YRS. MAX LIFE: MU & TRAINLINE HOSES)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkIAHPRv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkIAHPRv2", "checkIAHPRv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkIAHPRv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  transitionCircuit: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TRANSITION CIRCUIT",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT TRANSITION CIRCUIT FOR PROPER FUNCTION. REPAIR AS NECESSARY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkITCPFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkITCPFv2", "checkITCPFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkITCPFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  speedIndicator: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SPEED INDICATOR",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK FOR PROPER OPERATION. CALIBRATE AS NEEDED.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCPOCANv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCPOCANv2", "checkCPOCANv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCPOCANv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "COMPLETE RADAR SELF TEST TO VERIFY WHEEL CREEP PROTECTION IS FUNCTIONING PROPERLY (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCRSTVWCPFPv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCRSTVWCPFPv2", "checkCRSTVWCPFPv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCRSTVWCPFPv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  engineCoolingSystem: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ENGINE COOLING SYSTEM",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL COOLING FANS FUNCTION PROPERLY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCACFFPv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCACFFPv2", "checkCACFFPv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCACFFPv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK ALL FUSES IN COOLING FAN CIRCUIT (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAFICFCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCAFICFCv2", "checkCAFICFCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCAFICFCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL SHUTTERS ACTIVATE ALONG WITH THE COOLING FANS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCASACFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCASACFv2", "checkCASACFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCASACFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK “V” BELTS & PULLEY BEARINGS (GREASE BEARINGS AS NECESSARY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check83",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check83", "check83-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check83_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL TEMPERATURE SWITCH’S FUNCTION (PUSH TEST BUTTON)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCATSFv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCATSFv2", "checkCATSFv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCATSFv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "RUN COOLING FAN SELF TEST (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkRCFSTv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkRCFSTv2", "checkRCFSTv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkRCFSTv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK ENTIRE COOLING SYSTEM FOR LEAKS (REPAIR IF NECESSARY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCECSFLv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCECSFLv2", "checkCECSFLv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCECSFLv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "PRESSURE CHECK COOLANT SYSTEM (ONLY IF COOLANT LEAK EXISTS)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkPCCSOICLv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkPCCSOICLv2", "checkPCCSOICLv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkPCCSOICLv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  primeMoversDieselEngineInspection: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "PRIME MOVER/DIESEL ENGINE INSPECTION",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT THE ENGINE: FUEL, OIL OR COOLANT LEAKS. DAMAGED OR MISSING COMPONENTS. PROPER OPERATION. (REPAIR AS NECESSARY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check91",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check91", "check91-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check91_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "REPLACE SEALS AS NEEDED: TOP DECK COVERS, INSPECTION COVERS, VALVE COVERS, ETC.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkRSANTDCICVCv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkRSANTDCICVCv2", "checkRSANTDCICVCv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkRSANTDCICVCv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT FOR EXHAUST LEAKS. REPAIR IF NEEDED.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkIFELRIv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkIFELRIv2", "checkIFELRIv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkIFELRIv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CLEAN CARBON TRAPS (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCCTIAv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCCTIAv2", "checkCCTIAv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCCTIAv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK ECM OR EMDEC CONNECTIONS (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCEECIAv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCEECIAv2", "checkCEECIAv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCEECIAv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM MANUAL PRIME HAND-PUMP FUNCTIONS PROPERLY (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCMPHPFPAv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCMPHPFPAv2", "checkCMPHPFPAv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCMPHPFPAv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK GOVERNOR LINKAGES & BEARINGS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCGLBv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkCGLBv2", "checkCGLBv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkCGLBv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title:
            "EMDEC ENGINES ONLY: CHECK AND RECORD INJECTOR RESPONSE TIMES. (NORMAL RESPONSE TIMES 1.20ms - 1.60ms). IF RESPONSE TIMES ARE OUTSIDE OF RANGE (0.60ms or less), FURTHER TROUBLESHOOTING IS REQUIRED. ",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkEMDECv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkEMDECv2", "checkEMDECv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkEMDECv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CYL.1",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder1",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "CYL.9",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder9",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CYL.2",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder2",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "CYL.10",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder10",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CYL.3",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder3",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "CYL.11",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder11",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CYL.4",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder4",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "CYL.12",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder12",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CYL.5",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder5",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "CYL.13",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder13",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CYL.6",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder6",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "CYL.14",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder14",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CYL.7",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder7",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "CYL.15",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder15",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CYL.8",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder8",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "CYL.16",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "cylinder16",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  accessoryDriveADA: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ACCESSORY DRIVE (ADA), ACCESSORY EQUIPMENT & BEARING ADAPTER(S) ",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK BELT(S) & PULLYS FOR PROPER ALIGNMENT & EXCESSIVE WEAR",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkBPA",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkBPA", "checkBPA-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkBPA_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "GREASE ALL ADA & ACCESSORY DRIVE BEARINGS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "greaseADA",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["greaseADA", "greaseADA-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "greaseADA_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT DRIVESHAFT(S) & COUPLING(S). LUBRICATE AS NEEDED.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "inspectDriveshafts",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["inspectDriveshafts", "inspectDriveshafts-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "inspectDriveshafts_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT DRIVE SYSTEMS ON TRACTION MOTOR BLOWERS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "inspectTMBDrive",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["inspectTMBDrive", "inspectTMBDrive-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "inspectTMBDrive_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "GREASE EQUIPMENT PILLOW BLOCK BEARINGS ON TRACTION MOTOR BLOWERS OR ANY OTHER APPLICABLE FITTINGS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "greasePBB",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["greasePBB", "greasePBB-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "greasePBB_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM ALL BLOWERS FUNCTION PROPERLY AND BLOW SUFFICIENT AIR TO THE INTENDED EQUIPMENT",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "confirmBlowers",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["confirmBlowers", "confirmBlowers-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "confirmBlowers_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "BEARING ADAPTER: CHECK TORQUE & GREASE AS NEEDED (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "bearingAdapter",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["bearingAdapter", "bearingAdapter-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "bearingAdapter_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "INSPECT GEARBOX TO BEARING ADAPTER COUPLING FOR DEFECTS (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "inspectGearboxCoupling",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["inspectGearboxCoupling", "inspectGearboxCoupling-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "inspectGearboxCoupling_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  checkFluidLevel: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK FLUID LEVELS (ADD OR REPLACE AS REQUIRED)",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ENGINE OIL",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkEOv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkEOv2", "checkEOv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkEOv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "COMPRESSOR OIL",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check94",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check94", "check94-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check94_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TRANSMISSION/GEARBOX OIL",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTGOv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkTGOv2", "checkTGOv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkTGOv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "GOVERNOR OIL",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check96",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check96", "check96-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check96_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "ENGINE COOLANT",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check95",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check95", "check95-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check95_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SLOBBER/RETENTION TANK (DRAIN IF NECESSARY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSRTv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkSRTv2", "checkSRTv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSRTv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "EFLANGE LUBRICATOR RESERVOIR (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check98",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check98", "check98-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check98_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "APU: AUXILIARY POWER UNIT (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAPUv2",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkAPUv2", "checkAPUv2-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkAPUv2_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  sandOperationApplication: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SAND OPERATION & APPLICATION",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST SANDER OPERATION & SAND APPLICATION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "testSanderOperation",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["testSanderOperation", "testSanderOperation-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "testSanderOperation_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FILL SAND TANKS (BOTH ENDS OF LOCOMOTIVE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "fillSandTanks",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["fillSandTanks", "fillSandTanks-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "fillSandTanks_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONFIRM PROPER ALIGNMENT OF SAND NOZZLES FOR PROPER APPLICATION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "confirmSandNozzleAlignment",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["confirmSandNozzleAlignment", "confirmSandNozzleAlignment-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "confirmSandNozzleAlignment_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "REPLACE ANY MISSING OR DEFECTIVE SANDER NOZZLE(S)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "replaceSanderNozzles",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["replaceSanderNozzles", "replaceSanderNozzles-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "replaceSanderNozzles_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK THE ENTIRE SANDING SYSTEM FOR LEAKS. REPAIR AS NECESSARY.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSandingSystemLeaks",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkSandingSystemLeaks", "checkSandingSystemLeaks-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkSandingSystemLeaks_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title:
            "CONFIRM SAND APPLIES DURING EMERGENCY. (SOME UNITS MAY NOT APPLY SAND UNTIL CERTAIN CRITERIA IS MET, DURING AN EMERGENCY APPLICATION)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "confirmSandEmergency",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["confirmSandEmergency", "confirmSandEmergency-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "confirmSandEmergency_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  eventRecorder: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "EVENT RECORDER ",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },

    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "DOWNLOAD LOG FILE FROM EVENT RECORDER",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "downloadLogEventRecorder",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["downloadLogEventRecorder", "downloadLogEventRecorder-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "downloadLogEventRecorder_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "VERIFY LIGHTS ON THE EVENT RECORDER & NO FAULTS PRESENT",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "verifyLightsEventRecorder",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["verifyLightsEventRecorder", "verifyLightsEventRecorder-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "verifyLightsEventRecorder_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  softwareUpdates: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SOFTWARE UPDATES ",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "UPDATE ANY NECESSARY SOFTWARE (TMV, EMDEC, EM2000, DIASYS/MTU, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "updateSoftware",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["updateSoftware", "updateSoftware-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "updateSoftware_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  washCleanLocomotive: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "WASH & CLEAN LOCOMOTIVE ",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "WASH ENTIRE LOCOMOTIVE (INSIDE CARBODY, TRUCKS & EXTERIOR OF CARBODY)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "washLocomotive",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["washLocomotive", "washLocomotive-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "washLocomotive_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  airBrakeSystemTests: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AIR BRAKE SYSTEM TESTS & INSPECTION",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST AIR BRAKE EQUIPMENT & BRAKE PIPE LEAKAGE (5psi/min.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check114",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check114", "check114-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check114_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK MAIN RESERVOIR LEAKAGE FROM 84 psi (3psi/min. max. 3 min. Test)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check115",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check115", "check115-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check115_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK BRAKE CYLINDER LEAKAGE (FULL-SERVICE APP.  5 Min. test)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check116",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check116", "check116-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check116_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK FOR CORRECT AIR PRESSURE SETTINGS: MR, BP, ER, & BC.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check117",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check117", "check117-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check117_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CONTROL AIR SYSTEM LEAKAGE. REPAIR AS NECESSARY (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check118",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check118", "check118-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check118_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CALIBRATE ALL AIR GAUGES (+/- 3PSI)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check119",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check119", "check119-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check119_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CALIBRATE AFM (AIR FLOW METER) 60CFM @ 90psi ON BRAKE PIPE (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check120",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check120", "check120-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check120_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST HORN & CROSSING BELL",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check121",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check121", "check121-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check121_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST SANDER OPERATION & SAND APPLICATION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check122",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check122", "check122-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check122_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK AUTOMATIC DRAIN VALVES FOR PROPER OPERATION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check123",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check123", "check123-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check123_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "DRAIN MOISTURE FROM MAIN RESERVOIRS, DIRT COLLECTORS & FILTERS",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check124",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check124", "check124-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check124_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "TEST MAIN RESERVOIR SAFETY VALVE",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check125",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check125", "check125-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check125_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK BRAKE CYLINDER PISTON TRAVEL. ADJUST AS NECESSARY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check126",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check126", "check126-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check126_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "AUXILIARY EMERGENCY BRAKE VALVE: OPERATION & IDENTIFICATION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check127",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check127", "check127-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check127_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "CHECK MAIN RESERVOIR SYSTEM FOR LEAKS. REPAIR AS NECESSARY.",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check128",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check128", "check128-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check128_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "PERFORM DIAGNOSTIC AIR BRAKE TEST: EPIC, CCBII, CCB26, ETC. (IF APPLICABLE)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check129",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check129", "check129-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check129_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "BLUE CARD & DOCUMENT HOLDER: CONDITION & CLARITY",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check130",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check130", "check130-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check130_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  wheelGeometryAndMiscClearance: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "WHEEL GEOMETRY & MISC. CLEARANCES",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "80px",
      },
      classes: {
        header2: "",
      },
      inlineData: false,
      minDataRowsCount: 1,
      columns: [
        {
          title: "POS",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text3",
        },
        {
          title: "FLNG. HT",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text4",
        },
        {
          title: "FLNG. THKNS",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text5",
        },
        {
          title: "RIM THKNS",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text6",
        },
        {
          title: "TREAD COND.",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text7",
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "tab1_filledBy",
        },
      ],
    },
    {
      heights: {
        header1: "80px",
      },
      classes: {
        header2: "",
      },
      inlineData: false,
      minDataRowsCount: 1,
      columns: [
        {
          title: "POS",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text8",
        },
        {
          title: "FLNG. HT",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text9",
        },
        {
          title: "FLNG. THKNS",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text10",
        },
        {
          title: "RIM THKNS",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text11",
        },
        {
          title: "TREAD COND.",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "text12",
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          className: "tabl-text-normal",
          accessor: "tab2_filledBy",
        },
      ],
    },
  ],
  coupleHeight: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "COUPLER HEIGHT",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FRONT",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text13",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text13_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "REAR",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text14",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text14_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  pilotHeight: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "PILOT HEIGHT",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FRONT",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text15",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text15_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "REAR",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text16",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text16_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  sideBearingClearance: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "SIDE BEARING CLEARANCE",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FRONT LEFT",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text17",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text17_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "FRONT RIGHT",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text18",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text18_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "REAR LEFT",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text19",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text19_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "REAR RIGHT",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text20",
          unBold: true,
          isValueOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 6,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 6,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "text20_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
  updateDocumentation: [
    {
      heights: {
        header1: "70px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "UPDATE DOCUMENTATION",
          colSpan: 24,
          className: "tbl-text-normal",
          accessor: "",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "Check Items",
          colSpan: 20,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
        {
          title: "Inspector Name",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "year",
          isTitleOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "UPDATE BLUE CARD INFORMATION",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check163",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check163", "check163-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check163_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: "UPDATE INSPECTION DATES",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "checkUpdateInspectionDates",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["checkUpdateInspectionDates", "checkUpdateInspectionDates-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "checkUpdateInspectionDates_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
    {
      heights: {
        header1: "40px",
      },
      classes: {
        header2: "",
      },
      inlineData: true,
      columns: [
        {
          title: " FILE ANY DOCUMENTATION PERTAINING TO THE INSPECTIONS PERFORMED (PACKING LISTS, AIR PARTS LISTS, ETC.)",
          colSpan: 16,
          leftAlign: true,
          className: "tbl-text-normal",
          accessor: "check164",
          unBold: true,
          isTitleOnly: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: ["check164", "check164-Na"],
          unBold: true,
          isValueOnly: true,
          formatter: formatter,
          dontJoinValues: true,
        },
        {
          title: "",
          colSpan: 4,
          centerAlign: true,
          className: "tbl-text-normal",
          accessor: "check164_filledBy",
          unBold: true,
          isValueOnly: true,
        },
      ],
    },
  ],
};

export const BlueCardItemsTitleSchema = [
  {
    heights: { header1: "60px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        colSpan: 1,
        rowSpan: 1,
        title: "Inspector Name",
        isTitleOnly: true,
        className: "tbl-text-normal",
        accessor: "",
      },
      {
        colSpan: 7,
        rowSpan: 1,
        title: "Items",
        isTitleOnly: true,
        className: "tbl-text-normal",
        accessor: "",
      },
    ],
  },
];

export const BlueCardItemsDataSchema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        colSpan: 1,
        rowSpan: 1,
        title: "User",
        isValueOnly: true,
        className: "tbl-text-normal",
        accessor: "userName",
      },
      {
        title: "Brakes",
        colSpan: 1,
        className: "tbl-text-normal",
        unBold: true,
        accessor: "item1",
        formatter: (vals) => {
          return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
        },
      },
      {
        title: "Running Gear",
        colSpan: 1,
        className: "tbl-text-normal",
        unBold: true,
        accessor: "item2",
        formatter: (vals) => {
          return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
        },
      },
      {
        title: "Cab Equip",
        colSpan: 1,
        className: "tbl-text-normal",
        unBold: true,
        accessor: "item3",
        formatter: (vals) => {
          return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
        },
      },
      {
        title: "Mech Equip",
        colSpan: 1,
        className: "tbl-text-normal",
        unBold: true,
        accessor: "item4",
        formatter: (vals) => {
          return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
        },
      },
      {
        title: "Elect Equip",
        colSpan: 1,
        className: "tbl-text-normal",
        unBold: true,
        accessor: "item5",
        formatter: (vals) => {
          return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
        },
      },
      {
        title: "Steam Gen",
        colSpan: 1,
        className: "tbl-text-normal",
        unBold: true,
        accessor: "item6",
        formatter: (vals) => {
          return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
        },
      },
      {
        title: "Safety Appl",
        colSpan: 1,
        className: "tbl-text-normal",
        unBold: true,
        accessor: "item7",
        formatter: (vals) => {
          return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
        },
      },
    ],
  },
];

export const BlueCardItemsTableSchema = {
  heights: { header1: "40px" },
  classes: { header2: "" },
  inlineData: false,
  columns: [
    {
      colSpan: 1,
      rowSpan: 1,
      title: "User",
      isValueOnly: true,
      className: "tbl-text-normal",
      accessor: "inspector_items_filledBy",
    },
    {
      title: "Brakes",
      colSpan: 1,
      className: "tbl-text-normal",
      unBold: true,
      accessor: "item1",
      formatter: (vals) => {
        return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
      },
    },
    {
      title: "Running Gear",
      colSpan: 1,
      className: "tbl-text-normal",
      unBold: true,
      accessor: "item2",
      formatter: (vals) => {
        return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
      },
    },
    {
      title: "Cab Equip",
      colSpan: 1,
      className: "tbl-text-normal",
      unBold: true,
      accessor: "item3",
      formatter: (vals) => {
        return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
      },
    },
    {
      title: "Mech Equip",
      colSpan: 1,
      className: "tbl-text-normal",
      unBold: true,
      accessor: "item4",
      formatter: (vals) => {
        return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
      },
    },
    {
      title: "Elect Equip",
      colSpan: 1,
      className: "tbl-text-normal",
      unBold: true,
      accessor: "item5",
      formatter: (vals) => {
        return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
      },
    },
    {
      title: "Steam Gen",
      colSpan: 1,
      className: "tbl-text-normal",
      unBold: true,
      accessor: "item6",
      formatter: (vals) => {
        return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
      },
    },
    {
      title: "Safety Appl",
      colSpan: 1,
      className: "tbl-text-normal",
      unBold: true,
      accessor: "item7",
      formatter: (vals) => {
        return <span style={{ fontSize: "25px" }}>{typeof vals === "boolean" ? (vals ? "✓" : "") : ""}</span>;
      },
    },
  ],
};

export const EngineHoursSchema = {
  heights: { header1: "40px" },
  classes: { header2: "" },
  inlineData: true,
  columns: [
    {
      title: "Engine Hours",
      colSpan: 5,
      rowSpan: 1,
      topAlign: true,
      className: "tbl-text-normal",
      accessor: "",
      isTitleOnly: true,
    },
    {
      title: "eng",
      colSpan: 3,
      rowSpan: 1,
      topAlign: true,
      className: "tbl-text-normal",
      accessor: "engHour",
      isValueOnly: true,
    },
  ],
};
export const PersonPerformingSchema = [
  {
    heights: {
      header1: "70px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "NAME OF PERSON(S) PERFORMING WORK",
        colSpan: 24,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: false,
    columns: [
      {
        title: "Name",
        colSpan: 8,
        centerAlign: true,
        className: "tbl-text-normal",
        accessor: "text28",
        unBold: true,
      },

      {
        title: "Signature",
        colSpan: 16,
        centerAlign: true,
        className: "tbl-text-normal",
        accessor: "signature",

        formatter: (id) => {
          return <SignatureImageImproved width={"30%"} signatureImage={id} />;
        },
        unBold: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/Periodic/92And184Days/92And184DaysSchema.jsx